// removed by extract-text-webpack-plugin
module.exports = {"block":"_3EM2zmRg1IyfqkJOYnP8y6","heading":"_2ZXAh2WMXIwjyNOah3BJeT","container":"ldHXrcBzoiNSmDjGrr7Jl","collaborators":"_1Sw9Z8RlhaqptgyxXQND-l","collaborators__item":"_3LoHAHn1UCH1EeJAEL84_c","collaborators__title":"_2imgUnMmqqFd2rTaTbGSVS","collaborators__content":"_3DXuL4MvNLKG_f2DZCCyp-","icon":"_3cZSMII8J8O4eHR3yWQseB","readMore":"_2x8Tk7qcBluSa56PaIfgVb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollaboratorLinksBlock/CollaboratorLinksBlock.module.scss
// module id = 741
// module chunks = 0